import React from "react";
import {Button, Grid, Typography} from "@mui/material";
import { useTranslation } from 'react-i18next';

const SentimentQuestion = ({tipo, sendAnswer, answer, theme}) => {
    const { t } = useTranslation('questions');
    console.log()
    return (
        <Grid sx={{position: 'relative'}} container justifyContent={"center"} alignItems={"center"}
              style={{textAlign: 'center', height: '100%', position:'relative'}} spacing={5}>
            <Grid item xs={12} height={'50%'}>
                <Button onClick={() => sendAnswer('yes')} variant={'sentiment'} risposta={'daccordo'} style={{opacity: answer==='no' && '0.2', background: theme.colors[0]}}>
                    <Typography variant={'h5'} fontWeight={'bold'} color={tipo === 'clickTo' ? '#263238' : ''}>{t('sentiment.yes')}</Typography>
                </Button>
            </Grid>
            <Grid item xs={12} height={'50%'}>
                <Button onClick={() => sendAnswer('no')} variant={'sentiment'} risposta={'nonDaccordo'} style={{opacity: answer==='yes' && '0.2', background: theme.colors[1]}}>
                    <Typography variant={'h5'} fontWeight={'bold'}>{t('sentiment.no')}</Typography>
                </Button>
            </Grid>
        </Grid>
    )
}

export default SentimentQuestion
